import { AnimatePresence, motion } from "framer-motion";
import { useEffect, useState } from "react";
import styled from "styled-components";
import assets from "../../../assets/assets";
import { IconController } from "../../Scripts/ImgController";
const Wrapper = styled.div`
  width: min(450px, calc(100vw - 32px));
  min-height: 64px;
  display: flex;
  flex-direction: row;
  align-items: center;
  background: #bfdbfe;
  border-radius: 12px;
  padding: 8px;
  gap: 8px;
  margin-top: 48px;
`;

const NotificationPopup = ({
  popup,
  setPopup,
  type,
  popupMessage,
  animDirectionTop,
}) => {
  const [message, setMessage] = useState("");
  useEffect(() => {
    if (popup) {
      setTimeout(() => {
        setPopup(false);
      }, 3000);
    }
  }, [popup, setPopup]);

  useEffect(() => {
    if (!popupMessage) return;
    // eslint-disable-next-line default-case
    switch (popupMessage) {
      // SUCCESS
      case "loginSuccess":
        setMessage("Амжилттай нэвтэрлээ");
        break;
      case "passwordChanged":
        setMessage("Нууц үг амжилттай шинэчлэгдлээ");
        break;
      case "accountChanged":
        setMessage("Дансны дугаар амжилттай солигдлоо");
        break;
      case "changeRequestSuccess":
        setMessage("Өөрчлөх хүсэлт амжилттай илгээгдлээ");
        break;
      case "accountNumberChanged":
        setMessage("Дансны мэдээлэл амжилттай солигдлоо");
        break;
      case "infoSuccess":
        setMessage("Гэрээний мэдээлэл амжилттай шинэчилэгдлээ");
        break;
      // INFO

      case "mailNotGood":
        setMessage("Mail хаяг шаардлага хангахгүй байна");
        break;
      case "mail_user_not_found":
        setMessage("Цахим хаяг дээр бүртгэлтэй нийтлэгч олдсонгүй");
        break;
      case "fillTheFields":
        setMessage("Та талбаруудыг бүрэн бөглөнө үү");
        break;
      case "nothingChanged":
        setMessage("Өөрчлөлт хийгдээгүй байна");
        break;
      case "sessionOut":
        setMessage("Нэвтрэх эрхийн хугацаа дууссан байна");
        break;
      case "resendOTP":
        setMessage("Баталгаажуулах кодыг дахин илгээлээ");
        break;

      // WARNING

      case "loginFailed":
        setMessage("Нэвтрэх нэр эсвэл нууц үг буруу байна");
        break;
      case "infoFailed":
        setMessage("Гэрээний мэдээлэл дутуу байна!");
        break;
      case "warningContract":
        setMessage(
          "Энэхүү гэрээг сонгох бол та биечлэн ирж гэрээ хийнэ үү эсвэл contact@mmusic.mn-рүү холбогдоно уу"
        );
        break;
      case "otpFailed":
        setMessage("Баталгаажуулах код буруу байна");
        break;
      case "passwordMismatched":
        setMessage(
          "Нууц үгүүд таарахгүй байна. Та нууц үгээ алдаагүй давтан оруулна уу."
        );
        break;
      case "currentPasswordWrong":
        setMessage("Одоогийн нууц үг таарахгүй байна.");
        break;
      case "newPasswordMismatched":
        setMessage("Шинэ нууц үгүүд таарахгүй байна.");
        break;
      case "dateExceeded":
        setMessage("Сонгосон хугацаа 6 сараас хэтэрч болохгүй");
        break;
      case "unauthorizedAccess":
        setMessage("Та artist.mmusic.mn-д бүртгэлгүй байна.");
        break;
      case "unauthorizedKaraokeAccess":
        setMessage("Та Караоке-д хандах эрхгүй байна");
        break;
      case "unauthorizedMusicAccess":
        setMessage("Та Music-д хандах эрхгүй байна");
        break;
      case "somethingWrong":
        setMessage("Ямар нэгэн алдаа гарлаа");
        break;
      default:
        setMessage(popupMessage);
    }
  }, [popupMessage]);

  return (
    <>
      {type === "Success" && popup ? (
        <AnimatePresence>
          {popup ? (
            <motion.div
              initial={{ y: animDirectionTop ? -50 : 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: animDirectionTop ? -50 : 50, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Wrapper
                style={{ background: "#A7F3D0", border: "1px solid #10B981" }}
              >
                <IconController
                  src={assets.svg.successIcon}
                  className="h-10 w-10"
                />
                <div className="flex flex-col flex-1">
                  <h5 className="text-sm font-medium">{message}</h5>
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    setPopup(false);
                  }}
                >
                  <IconController
                    src={assets.svg.popupClose}
                    className="w-6 h-6 "
                  />
                </div>
              </Wrapper>
            </motion.div>
          ) : (
            ""
          )}
        </AnimatePresence>
      ) : (
        ""
      )}
      {type === "Info" && popup ? (
        <AnimatePresence>
          {popup ? (
            <motion.div
              initial={{ y: animDirectionTop ? -50 : 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: animDirectionTop ? -50 : 50, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Wrapper
                style={{ background: "#BFDBFE", border: "1px solid #3B82F6" }}
              >
                <IconController
                  src={assets.svg.infoIcon}
                  className="h-10 w-10"
                />
                <div className="flex flex-col flex-1">
                  <h5 className="text-sm font-medium">{message}</h5>
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    setPopup(false);
                  }}
                >
                  <IconController
                    src={assets.svg.popupClose}
                    className="w-6 h-6 "
                  />
                </div>
              </Wrapper>
            </motion.div>
          ) : (
            ""
          )}
        </AnimatePresence>
      ) : (
        ""
      )}
      {type === "Warning" && popup ? (
        <AnimatePresence>
          {popup ? (
            <motion.div
              initial={{ y: animDirectionTop ? -50 : 50, opacity: 0 }}
              animate={{ y: 0, opacity: 1 }}
              exit={{ y: animDirectionTop ? -50 : 50, opacity: 0 }}
              transition={{ duration: 0.3 }}
            >
              <Wrapper
                style={{ background: "#FECACA", border: "1px solid #EF4444" }}
              >
                <IconController
                  src={assets.svg.warningIcon}
                  className="h-10 w-10"
                />
                <div className="flex flex-col flex-1">
                  <h5 className="text-sm font-medium">{message}</h5>
                </div>
                <div
                  className="cursor-pointer"
                  onClick={() => {
                    setPopup(false);
                  }}
                >
                  <IconController
                    src={assets.svg.popupClose}
                    className="w-6 h-6 "
                  />
                </div>
              </Wrapper>
            </motion.div>
          ) : (
            ""
          )}
        </AnimatePresence>
      ) : (
        ""
      )}
    </>
  );
};

export default NotificationPopup;
